import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import uuid from 'uuid/v1'

import { warn } from 'utils'
import { rectifyTrade } from 'utils/trade'

export const COOKIE_NAME = 'magic-link-context'

// The preview mark: this tab arrived from a VehicleLyfe preview or playground
// link, so nothing it does is recorded or sent. Kept in sessionStorage only, so
// it ends with the tab.
export const PREVIEW_MARK = 'iq-preview',
  PREVIEW_NOTICE = 'Preview — nothing is sent to the dealer',
  hasPreviewMark = () => {
    try {
      return window.sessionStorage.getItem(PREVIEW_MARK) === '1'
    } catch (e) {
      return false
    }
  },
  // Sets the mark for a hand-off cookie that carries `preview`, clears it for
  // one that does not; no cookie leaves it as it is.
  syncPreviewMark = cookieData => {
    if (isEmpty(cookieData)) return

    try {
      if (cookieData.preview === true)
        window.sessionStorage.setItem(PREVIEW_MARK, '1')
      else window.sessionStorage.removeItem(PREVIEW_MARK)
    } catch (e) {
      warn('Failed to update the preview mark')
    }
  }

// The hand-off trigger mark: the trigger type of the VehicleLyfe link whose
// hand-off opened this tab ('open-ro' for an open-RO link). Every event the tab
// sends carries it, so the dealer's regular lead can leave out what an open-RO
// lead already covers. Kept in sessionStorage only, so it ends with the tab.
export const HANDOFF_TRIGGER_MARK = 'iq-handoff-trigger',
  handoffTriggerType = () => {
    try {
      return window.sessionStorage.getItem(HANDOFF_TRIGGER_MARK)
    } catch (e) {
      return null
    }
  },
  // Sets the mark for a hand-off cookie that carries a `triggerType`, clears it
  // for one that does not; no cookie leaves it as it is.
  syncHandoffTrigger = cookieData => {
    if (isEmpty(cookieData)) return

    try {
      if (cookieData.triggerType)
        window.sessionStorage.setItem(HANDOFF_TRIGGER_MARK, cookieData.triggerType)
      else window.sessionStorage.removeItem(HANDOFF_TRIGGER_MARK)
    } catch (e) {
      warn('Failed to update the hand-off trigger mark')
    }
  }

// magic link cookie getter to hydrate customer tag from context
export const getCookie = key => {
    let cookie = document.cookie,
      output = cookie.split(/\s*;\s*/).reduce((ret, c) => {
        let pair = c.split(/\s*=\s*/)

        return {
          ...ret,
          [pair[0]]: pair
            .splice(1)
            .join('=')
            .replaceAll('+', '%20'), // TODO safe?
        }
      }, {})

    return decodeURIComponent(output[key])
  },
  convertMagicCookie = (magicCookie, useSqueezeJacketReplacement) => {
    let {
        firstName,
        lastName,
        phoneNumber,
        emailAddress,
        postalCode,
        zipCode,
        source,
        campaign,
        scenarioType,
        scenarioId,
        overrideLocalStorage,
        tradeParams = {},
        theme,
        rooftopName,
      } = magicCookie,
      magicCustomer

    //TODO: FSCRUM-1491 -- This behavior is only needed while the squeeze jacket
    //is around. The id has to be cleared for the squeeze jacket to work
    //properly for invites.
    if  (!useSqueezeJacketReplacement || !scenarioId){
      // null the trade id on decode to force reselect of trim/options
      //console.log("MAGIC-COOKIE-TRADE!!!", "DELETING TRADEPENDING ID", rooftopName, tradeParams.id, tradeParams.tradePendingId, useSqueezeJacketReplacement, scenarioId)
      delete tradeParams.id
      delete tradeParams.tradePendingId
    }else{
      //console.log("MAGIC-COOKIE-TRADE!!!", "NOT DELETING TRADEPENDING ID", rooftopName, tradeParams.id, tradeParams.tradePendingId, useSqueezeJacketReplacement)
    }

    magicCustomer = !isEmpty(magicCookie)
      ? {
          sessionId: magicCookie.deviceId || uuid(),
          firstName,
          lastName,
          source,
          campaign,
          phone: phoneNumber,
          email: get((emailAddress || '').split(';'), 0), // TODO sometimes there's a semicolon in the magic link
          zipCode: postalCode || zipCode, // this is to uuuu
          vehicleId: get(magicCookie, 'decodedInventoryParams.vehicleId'),
          trades: !isEmpty(tradeParams)
          ? [rectifyTrade(tradeParams, { confirmed: tradeParams.confirmed })]
            : [],
          theme,
          rooftopName,
        overrideLocalStorage: overrideLocalStorage ? overrideLocalStorage : false,
        scenarioType: scenarioType,
        scenarioId: scenarioId,
        }
      : {}

    return magicCustomer
  },
  getMagicCustomer = (useSqueezeJacketReplacment) => {
    let cookieData = {}

    try {
      cookieData = JSON.parse(getCookie(COOKIE_NAME))
    } catch (e) {
      warn('Failed to get magic customer')
    }
    syncPreviewMark(cookieData)
    syncHandoffTrigger(cookieData)
    return convertMagicCookie(cookieData, useSqueezeJacketReplacment)
  }

window.getMagicCustomer = getMagicCustomer

// The marks are also synced once as this module loads, before any component
// mounts and can track. A page load without the cookie leaves them as they are.
try {
  const cookieData = JSON.parse(getCookie(COOKIE_NAME))
  syncPreviewMark(cookieData)
  syncHandoffTrigger(cookieData)
} catch (e) {
  // no hand-off cookie on this page load
}
